import { setError, startSpinner, stopSpinner } from '../../actions/common/actionCreators';
import { CAP_APPLICATIONS_ACTION_TYPES } from '../../constants/actionTypes/capApplicationsActionTypes';
import endpoints from '../../constants/configs/endpoints';
import { IAppController, IApplications } from '../../modules/members/types/Applications.interface';
import API from '../../services/API';

const householdId = sessionStorage.getItem('encHouseHoldId');

export const setCapApplications = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_APPLICATIONS,
    payload: data,
});

export const setCurrentYear = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR,
    payload: data,
});

export const setCapController = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_CONTROLLER,
    payload: data,
});

export const setOutboundButtonStatus = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_OUTBOUND_BUTTON_STATUS,
    payload: data,
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchApplicationsDetails = (currentYear, _environment, callback) => async dispatch => {
    const todayDateTime = new Date().getTime();
    const url = endpoints.MEMBER_APP_LIST_GET_APPS.processReplacements({
        coverageYear: currentYear,
        newDateTime: todayDateTime,
        encHouseholdId: householdId,
    });
    const applicationsData: IApplications = await API.getData(url, dispatch, actions, true);
    if (applicationsData) {
        dispatch(setCapApplications(applicationsData));

        if (applicationsData?.currentApplications?.length > 0) {
            const caseNumber = applicationsData?.currentApplications?.[0]?.caseNumber;
            const outBoundButtonStatusData = await API.getData(
                endpoints.MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS.processReplacements({ caseNumber }),
                dispatch,
                actions,
                true,
            );
            dispatch(setOutboundButtonStatus(outBoundButtonStatusData?.result));
        }
    } else {
        console.error('Cannot get cap applications details', url);
    }
    callback();
};

export const fetchAppControllerInfo = (url, _environment) => async dispatch => {
    const data: IAppController = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setCapController(data.data));
    } else {
        console.error('Cannot get cap controller info', url);
    }
};
